import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { ExcelForecastCreatePayload } from '../../types';
import { ForecastUploadDrawerInner } from './forecast-upload-drawer-inner';

interface Props {
  isLoading?: boolean;
  title?: ReactElement | string;
  children: JSX.Element;
  isOpen?: boolean;
  handleClose: () => void;
  maxFileSize?: number; // in MB
  acceptedFileExtensions?: string;
  workspaceId: string;
  organisationId: string;
  isUpdateDrawer?: boolean;
  isPredictionsPage?: boolean;
  forecastData: ExcelForecastCreatePayload;
}

export const ForecastUploadDrawer = ({
  title = <FormattedMessage id="common.upload_file" defaultMessage="Upload a file" />,
  isOpen,
  children,
  ...rest
}: Props) => {
  return (
    <Sidebar
      open={!!isOpen}
      header={
        <Typography variant="h2" fontWeight="700" id="excel-upload-drawer-form-title">
          {title}
        </Typography>
      }
      aria-labelledby="excel-upload-drawer-form-title"
    >
      <ForecastUploadDrawerInner {...rest}>{children}</ForecastUploadDrawerInner>
    </Sidebar>
  );
};
